import type { UsageReportV2ReportItem } from '@vy/types';
import { formatDate } from '@vy/date';
import { splitPascalCase } from '@vy/string';
import { whenDefined, notDefined } from '@vy/null';
import { formatNumber as formatLocalisedNumber } from '@vy/number';

export function formatNumber(value: number | null | undefined): string {
  if (notDefined(value)) {
    return '';
  }

  return formatLocalisedNumber(value, 2);
}

export function formatReportDate(date: Date): string {
  return formatDate(date, 'DD.MM.YYYY');
}

export { splitPascalCase };

export function formatIntervalMonths(months: number | null | undefined): string {
  if (notDefined(months)) {
    return '';
  }

  switch (months) {
    case 1:
      return 'Monthly';
    case 2:
      return 'Bi Monthly';
    case 3:
      return 'Quarterly';
    case 6:
      return 'Bi Yearly';
    case 12:
      return 'Yearly';
    default:
      return `Every ${months} months`;
  }
}

export function formatTierTo(tier: UsageReportV2ReportItem['tier']): string {
  return whenDefined(tier.to, formatNumber, '');
}

export function formatCustomFieldValue(value: unknown): string {
  switch (true) {
    case notDefined(value):
      return '';
    case value instanceof Date:
      return formatReportDate(value);
    case typeof value === 'object':
      return JSON.stringify(value);
    default:
      return String(value);
  }
}
